import { Component, Input, Output, EventEmitter, ViewEncapsulation } from '@angular/core';

import { WebApiModel } from '../../../models/web-api.model';

@Component({
  /* eslint-disable @angular-eslint/component-selector */
  selector: 'sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class SidebarComponent {
  @Input() location: WebApiModel.Location;
  @Input() locationType: string;
  @Output() closeMapEventEmitter: EventEmitter<any> = new EventEmitter();

  closeMapButtonPressed() {
    this.closeMapEventEmitter.emit();
  }
}
